/* =========================================================================
   U Angel 1988 — 产品选项卡片（价格注入 + 切换加速）
   -------------------------------------------------------------------------
   【1】切换加速
     Horizon 切换变体时请求整页 HTML（本站 804 KB），但只使用其中
     <variant-picker> 那 4.9 KB。本段给请求补上 section_id，只渲染产品主区。
     传输 107 KB → 20 KB。区段响应若异常，自动退回整页，功能不受影响。
     关闭方法：把下方 FAST_SWITCH 改成 false。

   【2】价格注入
     把每个变体的价格写到卡片名称下方。
     主题每次切换都会用 morph 重绘 DOM，会删掉注入的价格节点；
     本段监听真实 DOM 变化，变化一停就在同一帧内补回，不靠固定延时。
     取价优先用页面内联数据（零请求），缺失才走 /products/{handle}.js。

   版本：cards 2026-10-28-v6 / fast 2026-10-28-v1
   本次只改本文件，样式表与「选项卡片设置」区段未改动。
   ========================================================================= */

(function () {
  'use strict';

  var BUILD_CARDS = '2026-10-28-v6';
  var BUILD_FAST = '2026-10-28-v1';

  /* 切换加速开关：改成 false 即关闭，价格注入不受影响 */

  var FAST_SWITCH = true;

  window.UA_VARIANT_CARDS_BUILD = BUILD_CARDS;
  window.UA_FAST_SWITCH_BUILD = FAST_SWITCH ? BUILD_FAST : 'off';

  /* =======================================================================
     1. 切换加速：给变体切换请求补 section_id
     ======================================================================= */

  (function fastSwitch() {
    if (!FAST_SWITCH || typeof window.fetch !== 'function') return;

    var native = window.fetch;

    function pickSectionId() {
      var picker =
        document.querySelector('variant-picker[data-template-product-match="true"]') ||
        document.querySelector('variant-picker[data-section-id]');

      var id = picker && picker.getAttribute('data-section-id');

      return id && id.indexOf('template--') === 0 ? id : null;
    }

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';

      /* 只处理产品页变体切换：同站相对路径、带 option_values、尚未限定区段
         （快速加购等入口本身已带 section_id，不会被命中） */

      if (
        url.charAt(0) !== '/' ||
        url.indexOf('option_values=') === -1 ||
        url.indexOf('section_id=') !== -1
      ) {
        return native.call(this, input, init);
      }

      var sectionId = pickSectionId();

      if (!sectionId) return native.call(this, input, init);

      var parsed;

      try {
        parsed = new URL(url, window.location.origin);
      } catch (error) {
        return native.call(this, input, init);
      }

      var self = this;
      var fullUrl = url;

      parsed.searchParams.set('section_id', sectionId);

      var fastUrl = parsed.pathname + '?' + parsed.searchParams.toString();

      return native
        .call(self, fastUrl, init)
        .then(function (response) {
          if (!response.ok) return native.call(self, fullUrl, init);

          var copy;

          try {
            copy = response.clone();
          } catch (error) {
            return response;
          }

          return copy.text().then(function (html) {
            /* 区段里没有选项选择器就退回整页，保证切换不失败 */

            return html.indexOf('<variant-picker') !== -1
              ? response
              : native.call(self, fullUrl, init);
          });
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') throw error;
          return native.call(self, fullUrl, init);
        });
    };
  })();

  /* =======================================================================
     2. 价格注入
     ======================================================================= */

  var PRICE_CLASS = 'ua-variant-price';
  var PICKER_SEL = 'variant-picker .variant-option--image-list';
  var LABEL_SEL = '.variant-option__image-label';
  var NAME_SEL = '.variant-option__button-label__text';

  var priceMap = null;
  var fetching = false;
  var observer = null;
  var observedRoot = null;
  var scheduled = false;
  var inInject = false;
  var moneyCache = {};

  function toAmount(price) {
    if (price === null || price === undefined) return null;

    if (typeof price === 'object') {
      var fromObject = Number(price.amount);
      return isFinite(fromObject) ? fromObject : null;
    }

    var cents = Number(price);

    if (!isFinite(cents) || cents <= 0) return null;

    return cents / 100;
  }

  function formatMoney(amount) {
    if (!isFinite(amount)) return null;

    var key = String(amount);

    if (moneyCache[key]) return moneyCache[key];

    var text = null;

    try {
      if (window.Shopify && window.Shopify.formatMoney && window.Shopify.money_format) {
        text = String(
          window.Shopify.formatMoney(Math.round(amount * 100), window.Shopify.money_format)
        ).trim();
      }
    } catch (error) {}

    if (!text) {
      var currency = 'USD';

      try {
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
          currency = window.Shopify.currency.active;
        }
      } catch (error) {}

      try {
        text = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency
        }).format(amount);
      } catch (error) {
        text = currency + ' ' + amount.toFixed(2);
      }
    }

    moneyCache[key] = text;
    return text;
  }

  function isEmpty(map) {
    for (var key in map) {
      if (Object.prototype.hasOwnProperty.call(map, key)) return false;
    }
    return true;
  }

  function mapFromVariants(variants, out) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];

      if (!variant || !variant.id) continue;

      var amount = toAmount(variant.price);

      if (amount === null) continue;

      out[String(variant.id)] = { amount: amount };
    }

    return out;
  }

  function readInline() {
    var map = {};

    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      mapFromVariants((meta && meta.product && meta.product.variants) || [], map);
    } catch (error) {}

    return map;
  }

  function fetchPrices(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        return mapFromVariants((data && data.variants) || [], {});
      })
      .catch(function () {
        return {};
      });
  }

  function getSettings() {
    var settings = window.UA_VARIANT_SETTINGS || {};

    return {
      namePreset:
        settings.namePreset && settings.namePreset !== 'theme' ? settings.namePreset : '',
      pricePreset:
        settings.pricePreset && settings.pricePreset !== 'theme' ? settings.pricePreset : ''
    };
  }

  function inject(map) {
    if (inInject) return;

    inInject = true;

    try {
      var labels = document.querySelectorAll(PICKER_SEL + ' ' + LABEL_SEL);
      var settings = getSettings();
      var hasPrices = map && !isEmpty(map);

      for (var i = 0; i < labels.length; i++) {
        var label = labels[i];
        var nameEl = label.querySelector(NAME_SEL);

        if (!nameEl) continue;

        if (settings.namePreset && !nameEl.classList.contains(settings.namePreset)) {
          nameEl.classList.add(settings.namePreset);
        }

        /* 价格必须紧跟名称。morph 会把它挪位、改造或复制，
           所以先校验位置，不合格的整体重建，避免重复或错位 */

        var found = label.querySelectorAll('.' + PRICE_CLASS);
        var keep = null;

        for (var k = 0; k < found.length; k++) {
          if (found[k].previousElementSibling === nameEl && keep === null) {
            keep = found[k];
          } else if (found[k].parentNode) {
            found[k].parentNode.removeChild(found[k]);
          }
        }

        if (keep) {
          if (settings.pricePreset && !keep.classList.contains(settings.pricePreset)) {
            keep.classList.add(settings.pricePreset);
          }

          continue;
        }

        if (!hasPrices) continue;

        var input = label.querySelector('input[data-variant-id]');

        if (!input) continue;

        var info = map[input.getAttribute('data-variant-id')];

        if (!info) continue;

        var text = formatMoney(info.amount);

        if (!text) continue;

        var price = document.createElement('span');
        price.className = PRICE_CLASS;

        if (settings.pricePreset) price.classList.add(settings.pricePreset);

        price.textContent = text;
        nameEl.insertAdjacentElement('afterend', price);
      }
    } finally {
      inInject = false;
    }
  }

  function load() {
    if (priceMap && !isEmpty(priceMap)) {
      inject(priceMap);
      return;
    }

    if (fetching) return;

    var inline = readInline();

    if (!isEmpty(inline)) {
      priceMap = inline;
      inject(priceMap);
      return;
    }

    var picker = document.querySelector('variant-picker[data-product-handle]');
    var handle = picker && picker.getAttribute('data-product-handle');

    if (!handle) return;

    fetching = true;

    fetchPrices(handle).then(function (map) {
      fetching = false;

      if (isEmpty(map)) return;

      priceMap = map;
      inject(priceMap);
    });
  }

  /* 同一轮 DOM 变化合并成一次：morph 是同步的一大段，
     所有改动会在它结束后的微任务里一次补回，不出现空白帧 */

  function schedule() {
    if (scheduled) return;

    scheduled = true;

    var run = function () {
      scheduled = false;

      if (priceMap) inject(priceMap);
      else load();
    };

    if (typeof Promise !== 'undefined') {
      Promise.resolve().then(run);
    } else {
      window.setTimeout(run, 0);
    }
  }

  /* 监听挂在 picker 的父节点：主题若整体替换 <variant-picker>，
     旧节点上的监听会失效，挂父级才能收到这一次变化 */

  function observe() {
    if (typeof MutationObserver === 'undefined') return;

    var picker = document.querySelector('variant-picker');

    if (!picker) return;

    var root = picker.parentNode;

    if (!root) return;

    if (root === observedRoot && observer) return;

    if (observer) observer.disconnect();

    observedRoot = root;

    observer = new MutationObserver(function () {
      var current = document.querySelector('variant-picker');

      if (current !== picker) {
        observe();
        picker = current;
      }

      schedule();
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function boot() {
    observe();
    load();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', function () {
    observedRoot = null;
    boot();
  });
})();
